import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toTripMasterLocation, tripMasterLocationsEqual } from "./tripMasterUrls";

/** Collapse legacy HotelsRiver public URLs to short TripMaster paths. */
export default function TripMasterUrlNormalizer() {
  const location = useLocation();
  const next = toTripMasterLocation({
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  });
  if (tripMasterLocationsEqual(location, next)) return null;
  return <Navigate to={`${next.pathname}${next.search}${next.hash}`} replace />;
}
